export const GOVGR_BTN = "govgr-btn";
export const GOVGR_BTN_PRIMARY = "govgr-btn-primary";
export const GOVGR_BTN_SECONDARY = "govgr-btn-secondary";
export const GOVGR_BTN_WARNING = "govgr-btn-warning";
export const GOVGR_BTN_DISABLED = "govgr-btn-disabled";
export const GOVGR_BTN_CTA = "govgr-btn-cta";
export const GOVGR_ARROW__RIGHT = "govgr-arrow--right";
export const GOVGR_LINK = "govgr-link";
